import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { describeVariantRestrictionModalDataAtom } from "./atoms";
import { Category } from "@CommonApi/categories";

export const useDescribeVariantRestrictionModal = () => {
  const { openModal } = useModals();
  const setDescribeVariantRestrictionData = useSetAtom(describeVariantRestrictionModalDataAtom);

  const openDescribeVariantRestrictionModal = (category: Category) => {
    setDescribeVariantRestrictionData(category);
    openModal("ModalDescribeVariantRestriction");
  };

  return { openDescribeVariantRestrictionModal };
};
